module.exports = __webpack_public_path__ + "static/media/attraction2.390bdf73.jpg";